const assembleUrlQuery = (url, obj = {}) => {
  let myUrl = url;
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] !== 'undefined') {
      if (myUrl.indexOf('?') > -1) {
        myUrl += `&${key}=${obj[key]}`;
      } else {
        myUrl += `?${key}=${obj[key]}`;
      }
      }
    });
    return myUrl;
  };

export default {
    assembleUrlQuery
}